 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		34: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		34: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"VipCuratedFolderTooltip","1":"AppStoreLink","2":"AuthModal","3":"AuthProvider","4":"CartNavDropdownContent","5":"Contact1stdibsModal","6":"Contact1stdibsModalAcuityEmbed","7":"Contact1stdibsModalTradeRepCircle","8":"ContactTradeRepModalChunk","9":"FavNotifications","10":"FbpvnyVpbaf","11":"MobileNavAppBanner","12":"MobileVipCuratedFolderCalloutContent","13":"NotificationsBodyComponents","14":"PrivacyPolicyChangeNoticeChunk","15":"TradeEnrollmentAndStatusUpdateLoader","16":"TradeEnrollmentAndStatusUpdateRenderer","17":"TradeExpiringPromoModalChunk","18":"TradeGeneralOnboardingModalChunk","19":"TradePromoModalChunk","20":"TradeRewards2020LevelUpModalRenderer","21":"TradeRewardsEndOfYearMessaging","22":"TradeRewardsLevelUpModalRenderer","23":"TradeRewardsLevelUpModalRendererWrapperChunk","24":"TradeRewardsNavigationTooltip","25":"TradeVerifyFirmReminderToast","26":"VipCuratedFolderTooltipContent","27":"abandonCheckoutAutoModal","28":"abandonCheckoutPreAuthOfferMessageModal","29":"backToTop","30":"chat","31":"checkoutSurvey","32":"contactDealerModal","33":"cookieNotification","35":"intlClientPolyfill","36":"makeOfferModal","37":"mobileFooter","38":"mobileHeader","39":"responsiveFooter","40":"responsiveHeader","41":"tradeAccountNavContent"}[chunkId]||chunkId) + "-legacy-buyer-f7e60985-20bf-43fb-adc1-012cb32c888a-" + "dc3e2d65d332fb7464f2" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"3":1,"5":1,"7":1,"8":1,"9":1,"11":1,"12":1,"13":1,"14":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"VipCuratedFolderTooltip","1":"AppStoreLink","2":"AuthModal","3":"AuthProvider","4":"CartNavDropdownContent","5":"Contact1stdibsModal","6":"Contact1stdibsModalAcuityEmbed","7":"Contact1stdibsModalTradeRepCircle","8":"ContactTradeRepModalChunk","9":"FavNotifications","10":"FbpvnyVpbaf","11":"MobileNavAppBanner","12":"MobileVipCuratedFolderCalloutContent","13":"NotificationsBodyComponents","14":"PrivacyPolicyChangeNoticeChunk","15":"TradeEnrollmentAndStatusUpdateLoader","16":"TradeEnrollmentAndStatusUpdateRenderer","17":"TradeExpiringPromoModalChunk","18":"TradeGeneralOnboardingModalChunk","19":"TradePromoModalChunk","20":"TradeRewards2020LevelUpModalRenderer","21":"TradeRewardsEndOfYearMessaging","22":"TradeRewardsLevelUpModalRenderer","23":"TradeRewardsLevelUpModalRendererWrapperChunk","24":"TradeRewardsNavigationTooltip","25":"TradeVerifyFirmReminderToast","26":"VipCuratedFolderTooltipContent","27":"abandonCheckoutAutoModal","28":"abandonCheckoutPreAuthOfferMessageModal","29":"backToTop","30":"chat","31":"checkoutSurvey","32":"contactDealerModal","33":"cookieNotification","35":"intlClientPolyfill","36":"makeOfferModal","37":"mobileFooter","38":"mobileHeader","39":"responsiveFooter","40":"responsiveHeader","41":"tradeAccountNavContent"}[chunkId]||chunkId) + "-legacy-buyer-f7e60985-20bf-43fb-adc1-012cb32c888a-" + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"4f6ef1ee6570b380ff62","3":"295ed575b04283010641","4":"31d6cfe0d16ae931b73c","5":"4301e26f55499014ae7b","6":"31d6cfe0d16ae931b73c","7":"5148f52b2357457297a1","8":"2b3d27bd184ddf76d995","9":"2c06e6e11aa79ad2e2c1","10":"31d6cfe0d16ae931b73c","11":"b8f2529e3d029d27b988","12":"ac8b041320250d4016b9","13":"ddf1f4b621d671445c6a","14":"dd85255efc67d99011e4","15":"31d6cfe0d16ae931b73c","16":"3d99bd008e3ff057b571","17":"66d0b56a5dc095d16451","18":"f3266821ce428958cbbe","19":"227afb90669630c52fc0","20":"20325ecd6b2f40497d1d","21":"244c897998b71469a609","22":"4bbe9fec6c84ee4f703f","23":"31d6cfe0d16ae931b73c","24":"b47009ffcdaaf53d5cb5","25":"55bcb6013023ad1ffc08","26":"d806d022800f2d209697","27":"81acb077a9c317784dfc","28":"3429c76349807280a574","29":"ddeb14367c4f58d06229","30":"0071c6f20d463442fef0","31":"11c978fbb98b721db8e1","32":"4050ff09222c24d34fab","33":"a52aa1ec7eba2aad0d2d","35":"31d6cfe0d16ae931b73c","36":"e25afb38dc6f96fc5281","37":"79e544915dcc1d681cde","38":"6fba97c9ce2095e5ac09","39":"e52beeb56a74a47d4c33","40":"ebdcdadd131844b48a28","41":"6a6764cbc4bf51793d71"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://a.1stdibscdn.com/dist/dibs-buyer-layout/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpwindow_dibs_buyer_layout_buyer"] = window["webpackJsonpwindow_dibs_buyer_layout_buyer"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
